import _is from "../value/is";
var exports = {};
var isValue = _is; // prettier-ignore

var possibleTypes = {
  "object": true,
  "function": true,
  "undefined": true
  /* document.all */

};

exports = function (value) {
  if (!isValue(value)) return false;
  return hasOwnProperty.call(possibleTypes, typeof value);
};

export default exports;